import { __rest } from 'tslib';
import React from 'react';
import AntSwitch from 'antd-core/es/switch';
import { useTheme } from '../../theme/Theme.js';
import { Container, Children } from './styled.js';
import { Group } from './Group/Group.js';

const BaseToggle = React.forwardRef((_a, ref) => {
    var { children, className, style } = _a, props = __rest(_a, ["children", "className", "style"]);
    const theme = useTheme();
    return (React.createElement(Container, { className: className, style: style, "$disabled": props.disabled },
        React.createElement(AntSwitch, Object.assign({ "data-testid": 'tend-ui-toggle' }, props, { ref: ref })),
        React.createElement(Children, { theme: theme, "$disabled": props.disabled, "$size": props.size }, children)));
});
const Toggle = Object.assign(BaseToggle, {
    displayName: 'Toggle',
    Group,
});

export { Toggle };
//# sourceMappingURL=Toggle.js.map
